import moment from 'utils/cops-moment';
import { laneConfig } from '../config';
import { dayViews, viewIds } from '../config/view';
import { calculateSnap, decimalToTime } from '../utils/date-functions';

const isDroppedOnDayBreaker = (workingDays, widthDay, droppedWidth, widthDayBreakPercentage) => {
  const amountDayBreakers = workingDays.length - 1;
  const dayBreakerBoundaries = Array(amountDayBreakers)
    .fill()
    ?.map((value, index) => ({
      // eslint-disable-next-line
      start: widthDay * (index + 1) + widthDayBreakPercentage * index,
      // eslint-disable-next-line
      end: widthDay * (index + 1) + widthDayBreakPercentage * (index + 1),
    }));
  for (let i = 0; i < dayBreakerBoundaries.length; i += 1) {
    const dayBreakerBoundary = dayBreakerBoundaries[i];
    if (droppedWidth > dayBreakerBoundary.start && droppedWidth < dayBreakerBoundary.end) {
      return true;
    }
  }

  return false;
};

// eslint-disable-next-line complexity
const getDayHourOfDroppedBlock = ({
  droppedLeftPx,
  ganttDimensions,
  viewDimensions,
  dateReference,
  view,
}) => {
  const {
    id,
    parameters: { widthDayBreaker },
  } = view;
  const { doSnap } = laneConfig;
  const { widthGantt, widthDay } = ganttDimensions;
  const { workingDays, startHour, endHour, amountOfDays } = viewDimensions;
  const amountDayBreakers = amountOfDays - 1;
  // eslint-disable-next-line
  const widthDayPx = (widthGantt - view?.parameters?.widthDayBreaker * amountDayBreakers) / amountOfDays;
  const snapToMinutes = calculateSnap(widthDayPx, endHour - startHour);

  if (workingDays && workingDays.length) {
    // calculation day dropped
    const dateReferenceMoment = moment()
      .year(dateReference.year)
      .month(dateReference.month)
      .date(dateReference.day);

    // adjust the working days for non-static views
    // like day or 2-day view
    let adjustedWorkingDays = workingDays;
    if (view?.id === viewIds.oneDay) {
      adjustedWorkingDays = [dateReferenceMoment.day()];
    } else if (view?.id === viewIds.twoDays) {
      adjustedWorkingDays = [dateReferenceMoment.day(), (dateReferenceMoment.day() + 1) % 7];
    }

    const droppedWidth = (droppedLeftPx / widthGantt) * 100;
    const widthDayBreakPercentage = (widthDayBreaker / widthGantt) * 100;
    // eslint-disable-next-line max-len
    const dayNumber = Math.floor(droppedWidth / (widthDay + widthDayBreakPercentage));

    // check if dropped on draybreaker
    if (
      isDroppedOnDayBreaker(adjustedWorkingDays, widthDay, droppedWidth, widthDayBreakPercentage)
    ) {
      return {
        error: 'CAN_NOT_BE_DROPPED',
      };
    }
    const amountWorkingDaysInWeek = adjustedWorkingDays.length;
    const weekDiff = Math.floor(dayNumber / amountWorkingDaysInWeek);
    let dayDropped = moment()
      .year(dateReference.year)
      .month(dateReference.month)
      .date(dateReference.day + (weekDiff * 7))
      .startOf('week')
      .add(dayNumber % workingDays.length, 'day');

    if (id === viewIds.month) {
      const day = dayNumber + 1;
      dayDropped = moment()
        .year(dateReference.year)
        .month(dateReference.month)
        .date(day);

      // check if dropped on next month
      const daysInMonth = dateReferenceMoment.daysInMonth();
      const dayDiff = daysInMonth - day;
      if (dayDiff < 0) {
        dayDropped = dayDropped.date(dayDiff * -1);
      }
    }
    if (dayViews.includes(id)) {
      dayDropped = moment()
        .year(dateReference.year)
        .month(dateReference.month)
        .date(dateReference.day)
        .add(dayNumber, 'days');
    }

    // get the dropped withed of the dropped day
    const droppedWidthOfDay =
      // eslint-disable-next-line
      ((droppedWidth - (dayNumber * widthDay + dayNumber * widthDayBreakPercentage)) / widthDay) *
      100;

    // get hour of dropped witdh
    let hourDropped = decimalToTime(
      // eslint-disable-next-line
      (endHour - startHour) * (droppedWidthOfDay / 100) + startHour,
      doSnap,
      snapToMinutes,
    );

    if (id === viewIds.month) {
      hourDropped = {
        hour: 8,
        minute: 0,
      };
    }

    return dayDropped
      .set({ hour: hourDropped.hour, minute: hourDropped.minute })
      .format('YYYY-MM-DDTHH:mm:ss');
  }

  return {
    error: 'ENABLE_TO_GET_DATE',
  };
};

export default getDayHourOfDroppedBlock;
